import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.MY_ISSUANCE,
    name: "myIssuances",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.MY_ISSUANCES.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.MY_ISSUANCES.PERMISSIONS,
    },
    component: () => import("@/modules/MyIssuances/views/MyIssuanceList.vue"),
  },
  {
    path: PATH.FLIGHTS_ISSUANCE_DETAILS,
    name: "myIssuancesDetailsPage",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.MY_ISSUANCES_DETAILS.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.MY_ISSUANCES_DETAILS.PERMISSIONS,
    },
    component: () =>
      import("@/modules/MyIssuances/views/MyIssuanceDetailPage.vue"),
  },
];

export default routes;
